export const DETAILS_MODAL = 'detailsModal';

export const ALL_NOTIFICATIONS_MODAL = 'allNotificationsModal';

export const NOTIFICATIONS_LOCAL_STORAGE_NAME = 'myNotifications';

// Notification incident types
export const ALL = 'All';

export const UNRESOLVED = 'Unresolved';

export const SCHEDULED = 'Scheduled';

export const NONE = 'None';
